// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RepliedMessage__container-f2d2a5 {
  box-sizing: border-box;
  padding: 0px;
}

.RepliedMessage__content-e92905 {
  padding-inline-start: 8px;
}

.RepliedMessage__theme-1-f61f35.RepliedMessage__container-f2d2a5 {
  min-width: 200px;
}

.RepliedMessage__theme-1-f61f35 .RepliedMessage__content-e92905 {
  border-left: 2px solid var(--chat-bubble-primary);
}

.RepliedMessage__theme-1-f61f35 .RepliedMessage__title-e51372 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--chat-bubble-primary);
}

.RepliedMessage__theme-2-f6c232.RepliedMessage__container-f2d2a5 {
  width: auto;
  max-width: 164px;
  padding: 4px;
  border-radius: 6px;
  background: var(--average-background);
}

.RepliedMessage__theme-2-f6c232 .RepliedMessage__content-e92905 {
  border-left: 2px solid var(--text-on-background);
}

.RepliedMessage__theme-2-f6c232 .RepliedMessage__title-e51372 {
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-spacing-subtitle-2);
  color: var(--text-on-background);
}

.RepliedMessage__theme-2-f6c232 .RepliedMessage__text-dacd71 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-2);
  color: var(--text-on-background);
  opacity: 0.7;
}

.RepliedMessage__theme-2-f6c232 .RepliedMessage__icon-c4b983 {
  fill: var(--text-on-background);
}

.RepliedMessage__theme-2-f6c232 a {
  color: var(--text-on-background);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/components/RepliedMessage/RepliedMessage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,iDAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,iCAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;AACF;;AAEA;EACE,gDAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,gCAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,gCAAA;EACA,YAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,gCAAA;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  padding: 0px;\n}\n\n.content {\n  padding-inline-start: 8px;\n}\n\n.theme-1.container {\n  min-width: 200px;\n}\n\n.theme-1 .content {\n  border-left: 2px solid var(--chat-bubble-primary);\n}\n\n.theme-1 .title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--chat-bubble-primary);\n}\n\n.theme-2.container {\n  width: auto;\n  max-width: 164px;\n  padding: 4px;\n  border-radius: 6px;\n  background: var(--average-background);\n}\n\n.theme-2 .content {\n  border-left: 2px solid var(--text-on-background);\n}\n\n.theme-2 .title {\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-spacing-subtitle-2);\n  color: var(--text-on-background);\n}\n\n.theme-2 .text {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-2);\n  color: var(--text-on-background);\n  opacity: 0.7;\n}\n\n.theme-2 .icon {\n  fill: var(--text-on-background);\n}\n\n.theme-2 a {\n  color: var(--text-on-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RepliedMessage__container-f2d2a5`,
	"content": `RepliedMessage__content-e92905`,
	"theme-1": `RepliedMessage__theme-1-f61f35`,
	"theme1": `RepliedMessage__theme-1-f61f35`,
	"title": `RepliedMessage__title-e51372`,
	"theme-2": `RepliedMessage__theme-2-f6c232`,
	"theme2": `RepliedMessage__theme-2-f6c232`,
	"text": `RepliedMessage__text-dacd71`,
	"icon": `RepliedMessage__icon-c4b983`
};
module.exports = ___CSS_LOADER_EXPORT___;
